// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import './ProgressIndicator.css';

interface ProgressIndicatorProps {
  totalSteps: number;
  currentStep: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ totalSteps, currentStep }) => {
  return (
    <div className="progress-container">
      {Array.from({ length: totalSteps }).map((_, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;

        let dotClass = 'progress-dot';
        if (isActive) dotClass += ' progress-dot-active';
        if (isCompleted) dotClass += ' progress-dot-completed';

        return <div key={index} className={dotClass} />;
      })}
    </div>
  );
};

export default ProgressIndicator;
